// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { AppState } from '@store/reducers';
import * as GeneralReducer from '@store/reducers/general.reducer';

export const selectGeneralState = (state: AppState) => state.general;

export const selectCurrentPage = createSelector(
  selectGeneralState,
  (state: GeneralReducer.GeneralState) => state.currentPage
);
